import { render, staticRenderFns } from "./checkoutPage.vue?vue&type=template&id=fa5114d4&scoped=true&"
import script from "./checkoutPage.vue?vue&type=script&lang=ts&"
export * from "./checkoutPage.vue?vue&type=script&lang=ts&"
import style0 from "./checkoutPage.vue?vue&type=style&index=0&id=fa5114d4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../wellness/node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa5114d4",
  null
  
)

export default component.exports